// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/Services/DataEngg/section-3.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/Services/DataEngg/ellipse.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/Services/DataEngg/section-6.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/Services//DataEngg/wavelength.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../assets/Services/DataEngg/section-9.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.data-engg-section-1 {
    display: flex;
    color: #20303F;
    width: 80%;
    margin: auto;
    margin-bottom: 6rem;
    margin-top: 250px;
}

.data-engg-section-1-left {
    width: 75%;
}

.data-engg-section-1-left p:nth-child(1) {
    margin: 0;
    font-size: var(--font-size1);
    font-weight: bold;
}

.data-engg-section-1-left p:nth-child(2) {
    font-size: var(--font-size2);
    font-weight: lighter;
    margin: 0;
}

.data-engg-section-1-left span {
    margin: 0;
    font-size: var(--font-size2);
    font-weight: 900;
    margin: 0;
}

.data-engg-section-1-right {
    width: 60%;

    & img {
        width: 100%;
    }
}

.data-engg-section-3 {
    display: flex;
    width: 70%;
    justify-content: center;
    margin: auto;
    margin-bottom: 9rem;
}

.data-engg-section-3-left {
    width: 35%;
    display: flex;
    flex-direction: column;
    justify-content: center;

    & p:nth-child(1) {
        font-size: var(--font-size3);
        margin: 0;
    }

    & p:nth-child(2) {
        font-size: var(--font-size3);
        font-weight: bold;
        margin: 0;
        margin-bottom: 2rem;
    }

    & p:nth-child(3),
    & p:nth-child(4) {
        font-size: var(--font-size4);
        margin-bottom: 2rem;
    }
}

.data-engg-section-3-right {
    display: flex;
    justify-content: space-around;
    width: 50%;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center 190px;
    border-radius: 1rem;
    margin: auto;
    padding: 2%;

    & p:nth-child(1) {
        font-size: var(--font-size6);
        font-weight: bold;
    }

    & p:nth-child(2) {
        font-size: 1.2rem
    }
}

.data-engg-section-3-right-1,
.data-engg-section-3-right-2 {
    width: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 1rem;
    padding: 0.5rem;


    & div {
        padding: 1rem;
        background: rgba(255, 255, 255, 0.7);
        -webkit-backdrop-filter: blur(5px);
                backdrop-filter: blur(5px);
        border-radius: 1rem;
        border: 5px solid white;
        box-shadow: rgba(17, 17, 26, 0.1) 0px 0px 16px;
    }
}

.data-engg-section-4 {
    width: 70%;
    margin: auto;
    margin-bottom: 5rem;
}

.data-engg-section-4-container {
    padding: 5rem 0;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-repeat: no-repeat;
    background-position: center;
}

.data-engg-section-4-top {
    font-size: 36px;
    margin-bottom: 2rem;

    p {
        margin: 0;
    }

    & p:nth-child(1) {
        font-weight: lighter;
    }

    & p:nth-child(2) {
        font-weight: bold;
    }
}

.data-engg-section-4-bottom-1,
.data-engg-section-4-bottom-2 {
    display: flex;
    justify-content: space-between;

    & div {
        padding: 1rem;
        border-radius: 1rem;
        background: white;
    }
}

.data-engg-section-4-bottom-1 div {
    width: 30%;
    margin-bottom: 2rem;
}

.data-engg-section-4-bottom-2 div {
    width: 45%;
}

.data-engg-section-4-bottom-1,
.data-engg-section-4-bottom-2 {
    & img {
        width: 70px;
        height: 70px;
    }
}

.section-4-bold-head {
    font-size: 32px;
    font-weight: bold;
}

.section-4-desc {
    font-size: 18px;
}

.data-engg-section-5 {
    padding: 1%;
    display: flex;
    font-size: 24px;
    font-weight: 400;
    justify-content: center;
    align-items: center;
    gap: 3rem;
    margin-bottom: 5rem;

    & div:nth-child(1) {
        width: max-content;
    }

    & div:nth-child(2) {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 2rem;
        width: 20%;
        height: 50px;

        & img {
            width: 50%;
        }
    }
}

.data-engg-section-6 {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    background-position: center;
    background-size: cover;
    margin-bottom: var(--margin-bottom-web);
    height: 600px;
    padding: 1%;

    & p:nth-child(1) {
        font-size: 72px;
        margin: 0;
    }

    & p:nth-child(2) {
        font-size: 24px;
    }
}

.section-6-content {
    display: flex;
    flex-direction: column;
    width: 45%;
    margin: auto;
    text-align: center;
    gap: 10rem;
    height: max-content;

    & div:nth-child(2) {
        display: flex;
        justify-content: center;
    }
}

.data-engg-section-7 {
    margin-bottom: 10rem;
}

.section-7-bg {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
}

.section-7-top {
    font-size: 28px;
    width: 70%;
    margin: auto;
    margin-bottom: 2rem;

    & p {
        margin: 0;
    }

    & p:nth-child(1) {
        font-weight: lighter;
    }
}

.section-7-bottom {
    width: 70%;
    margin: auto;
    display: flex;
    justify-content: space-between;

    & div {
        width: 30%;
        padding: 1%;
        border: 1px solid #90C8E5;
        background: white;
        border-radius: 1em;
    }

    & img {
        width: 100%;
        aspect-ratio: 16/9;
        border-radius: 1rem;
    }
}

.section-7-title,
.section-7-desc {
    font-size: 16px;
}

.section-7-title {
    font-weight: bold;
}

.section-7-head {
    font-size: 21px;
}

.data-engg-section-8 {
    margin-top: 0px;
    margin-bottom: -25%;
}

.data-engg-section-8-top {
    text-align: center;
    color: #20303F;
}

.data-engg-section-8-top>:nth-child(3) {
    margin-top: 12px;
    font-size: 20px;
    font-weight: 400;
    line-height: 30.66px;
}

.data-engg-section-8-top>:nth-child(1),
.data-engg-section-8-top>:nth-child(2) {
    font-size: 36px;
    line-height: 48px;
    margin: 0;
}

.data-engg-section-9 {
    margin-bottom: 10rem;
}

.section-9-top {
    width: 80%;
    margin: auto;
    margin-bottom: 2rem;
    font-size: 28px;
    color: #20303F;

    & p {
        margin: 0;
        font-weight: lighter;
    }
}

.section-9-bottom {
    display: flex;
    width: 80%;
    margin: auto;
    gap: 1rem;

    & ul {
        font-size: 14px;
    }
}

.data-engg-section-9-bottom-left,
.data-engg-section-9-bottom-right {
    width: 50%;
}

.data-engg-section-9-bottom-left {
    display: grid;
    grid-template-columns: repeat(2, 1fr);

    & div {
        padding: 1rem;
    }

    & div:nth-child(1) {
        border-bottom: 1px solid #4FC1AD;
        border-right: 1px solid #4FC1AD;
        border-radius: 40px;
    }

    & div:nth-child(2) {
        border-bottom: 1px solid #4FC1AD;
        border-left: 1px solid #4FC1AD;
        border-radius: 40px;
    }

    & div:nth-child(3) {
        border-top: 1px solid #4FC1AD;
        border-right: 1px solid #4FC1AD;
        border-radius: 40px;
    }

    & div:nth-child(4) {
        border-top: 1px solid #4FC1AD;
        border-left: 1px solid #4FC1AD;
        border-radius: 40px;
    }

    & img {
        width: 60px;
        height: 60px;
    }
}

.data-engg-section-9-bottom-right {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    font-size: 36px;
    display: flex;
    flex-direction: column;
    justify-content: end;
    align-items: center;
    color: white;
    border-radius: 1rem;

    & div {
        width: 90%;
        margin-bottom: 2rem;

        & p {
            margin: 0;
            font-weight: lighter;
        }
    }
}

.section-9-bottom-head {
    font-size: 20px;
    font-weight: bold;
}

/* Tablet Version */
@media screen and (min-width:960px) and (max-width: 1360px) {
    .data-engg-section-6 {
        height: 400px;
        padding: 1%;


        & p:nth-child(1) {
            font-size: 48px;
        }

        & p:nth-child(2) {
            font-size: 20px;
        }
    }

    .section-6-content {
        gap: 5rem
    }

    .data-engg-section-9 {
        margin-top: 25rem;
    }

    .section-9-bottom {
        flex-direction: column;
        gap: 2rem;
    }

    .data-engg-section-9-bottom-left,
    .data-engg-section-9-bottom-right {
        width: 100%;
    }

    .data-engg-section-9-bottom-right {
        height: 800px;
    }
}


/* Mobile Version */
@media screen and (min-width:300px) and (max-width: 500px) {
    .data-engg-section-1 {
        flex-direction: column;
        margin-bottom: var(--margin-bottom-mobile);
        width: 80%;
        margin-top: 0px;
    }

    .data-engg-section-1-left,
    .data-engg-section-1-right {
        width: 100%;
    }

    .data-engg-section-1-left p:nth-child(1) {
        font-size: 21px;
    }

    .data-engg-section-1-left p:nth-child(2),
    .data-engg-section-1-left span {
        font-size: 41px;
    }

    .data-engg-section-3 {
        flex-direction: column;
        width: 90%;
        margin-bottom: var(--margin-bottom-mobile);
    }

    .data-engg-section-3-left {
        width: 100%;

        & p:nth-child(1),
        & p:nth-child(2) {
            font-size: 28px;
        }

        & p:nth-child(2) {
            margin-bottom: 1rem;
        }

        & p:nth-child(3),
        & p:nth-child(4) {
            font-size: 14px;
            margin-bottom: 1rem;
        }
    }

    .data-engg-section-3-right {
        width: 100%;
        padding: 1%;
        gap: 0.5rem;
        background-position: center 140px;

        & p:nth-child(1) {
            font-size: 20px;
        }

        & p:nth-child(2) {
            font-size: 15px;
        }
    }

    .data-engg-section-3-right-1,
    .data-engg-section-3-right-2 {
        padding: 0;

        & div {
            padding: 0.5rem;
        }
    }

    .data-engg-section-4 {
        width: 100%;
        margin-bottom: 2.5rem;
    }

    .data-engg-section-4-container {
        width: 80%;
        padding:0;
        margin: auto;
        background-image: none;
    }

    .data-engg-section-4-bottom-1,
    .data-engg-section-4-bottom-2 {
        flex-direction: column;
    }

    .data-engg-section-4-bottom-2 {
        gap: 2rem;
    }

    .data-engg-section-4-bottom-1 div {
        width: 90%;
        margin-bottom: 2rem;
        border: 1px solid #4fc2ac;
    }

    .data-engg-section-4-bottom-2 div {
        width: 90%;
        border: 1px solid #4fc2ac;
    }

    .section-4-bold-head {
        font-size: 24px;
    }

    .section-4-desc {
        font-size: 14px;
    }

    .data-engg-section-5 {
        flex-direction: column;
        gap: 0.5rem;
        margin-bottom: 2.5rem;

        & div:nth-child(2) {
            width: 50%;
        }
    }

    .data-engg-section-6 {
        height: 400px;
        padding: 1%;
        margin-bottom: var(--margin-bottom-mobile);

        & p:nth-child(1) {
            font-size: 36px;
        }

        & p:nth-child(2) {
            font-size: 16px;
        }
    }

    .section-6-content {
        gap: 5rem;
        width: 85%
    }

    .data-engg-section-7 {
        margin-bottom: 5rem;
    }

    .section-7-bg {
        background-image: none;
    }

    .section-7-bottom {
        flex-direction: column;
        gap: 1rem;
        width: 90%;

        & div {
            width: 90%;
            padding: 2%;
            margin: auto;
        }
    }

    .data-engg-section-8 {
        margin-bottom: -10%;
    }

    .data-engg-section-9 {
        margin-top: 8rem;
        margin-bottom: var(--margin-bottom-mobile);
    }

    .section-9-bottom {
        flex-direction: column;
    }

    .data-engg-section-9-bottom-left {
        width: 100%;
        grid-template-columns: repeat(1, 1fr);


        & img {
            width: 40px;
            height: 40px;
        }
    }

    .section-9-bottom-head {
        font-size: 24px;
    }

    .data-engg-section-9-bottom-right {
        width: 100%;
        font-size: 30px;
        height: 400px;
    }
}


/* Tablet Version */
@media screen and (min-width:600px) and (max-width: 1024px) {
    .data-engg-section-1 {
        margin-top: 0px;
        margin-bottom: var(--margin-bottom-mobile);
    }

    .data-engg-section-1-left p:nth-child(2),
    .data-engg-section-1-left span {
        font-size: 45px;
    }

    .data-engg-section-1-right {
        width: 70%;

        & img {
            width: 100%;
        }
    }

    .data-engg-section-3 {
        flex-direction: column;
        width: 90%;
        margin-bottom: var(--margin-bottom-mobile);
    }

    .data-engg-section-3-left {
        width: 100%;
    }

    .data-engg-section-3-right {
        width: 100%;
        padding: 1%;
        gap: 0.5rem;
        background-position: center 60px;
    }

    .data-engg-section-3-right-1,
    .data-engg-section-3-right-2 {
        padding: 0;

        & div {
            padding: 0.5rem;
        }
    }

    .data-engg-section-4 {
        width: 100%;
        margin-bottom: 5rem;
    }

    .data-engg-section-4-container {
        width: 80%;
        padding: 3rem 0 0 0;
        margin: auto;
        background-image: none;
    }

    .data-engg-section-4-bottom-1,
    .data-engg-section-4-bottom-2 {
        flex-direction: column;
    }

    .data-engg-section-4-bottom-2 {
        gap: 2rem;
    }

    .data-engg-section-4-bottom-1 div,
    .data-engg-section-4-bottom-2 div {
        width: 90%;
        margin: auto;
        border: 1px solid #4fc2ac;
    }

    .data-engg-section-4-bottom-1 div {
        margin-bottom: 2rem;
    }

    .data-engg-section-5 {
        margin-bottom: var(--margin-bottom-mobile);
    }

    .data-engg-section-6 {
        height: 400px;
        padding: 1%;

        & p:nth-child(1) {
            font-size: 36px;
        }

        & p:nth-child(2) {
            font-size: 16px;
        }
    }

    .section-6-content {
        gap: 6rem;
        width: 60%
    }

    .data-engg-section-7 {
        width: 100%;
        margin: auto;
        margin-bottom: 5rem;
    }

    .section-7-title,
    .section-7-desc {
        font-size: 14px;
    }

    .section-7-head {
        font-size: 18px;
    }

    .section-7-top {
        width: 90%;
    }

    .section-7-bottom {
        width: 90%;
        margin: auto;
    }

    .data-engg-section-9 {
        margin-top: 20rem;
        margin-bottom: var(--margin-bottom-mobile);
    }

    .section-9-bottom {
        flex-direction: column;
    }

    .data-engg-section-9-bottom-left {
        width: 100%;
        grid-template-columns: repeat(2, 1fr);

        & img {
            width: 40px;
            height: 40px;
        }
    }

    .data-engg-section-9-bottom-right {
        width: 100%;
        font-size: 30px;
        height: 800px;
    }
}

@media screen and (min-width:600px) and (max-width:700px) {
    .data-engg-section-3-right {
        background-position: center 150px;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/Services/DataEngg.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,cAAc;IACd,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,SAAS;IACT,4BAA4B;IAC5B,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;IAC5B,oBAAoB;IACpB,SAAS;AACb;;AAEA;IACI,SAAS;IACT,4BAA4B;IAC5B,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,UAAU;;IAEV;QACI,WAAW;IACf;AACJ;;AAEA;IACI,aAAa;IACb,UAAU;IACV,uBAAuB;IACvB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,uBAAuB;;IAEvB;QACI,4BAA4B;QAC5B,SAAS;IACb;;IAEA;QACI,4BAA4B;QAC5B,iBAAiB;QACjB,SAAS;QACT,mBAAmB;IACvB;;IAEA;;QAEI,4BAA4B;QAC5B,mBAAmB;IACvB;AACJ;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,UAAU;IACV,yDAAqE;IACrE,wBAAwB;IACxB,4BAA4B;IAC5B,iCAAiC;IACjC,mBAAmB;IACnB,YAAY;IACZ,WAAW;;IAEX;QACI,4BAA4B;QAC5B,iBAAiB;IACrB;;IAEA;QACI;IACJ;AACJ;;AAEA;;IAEI,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;IACT,eAAe;;;IAGf;QACI,aAAa;QACb,oCAAoC;QACpC,kCAA0B;gBAA1B,0BAA0B;QAC1B,mBAAmB;QACnB,uBAAuB;QACvB,8CAA8C;IAClD;AACJ;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,yDAAmE;IACnE,4BAA4B;IAC5B,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,mBAAmB;;IAEnB;QACI,SAAS;IACb;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,iBAAiB;IACrB;AACJ;;AAEA;;IAEI,aAAa;IACb,8BAA8B;;IAE9B;QACI,aAAa;QACb,mBAAmB;QACnB,iBAAiB;IACrB;AACJ;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,UAAU;AACd;;AAEA;;IAEI;QACI,WAAW;QACX,YAAY;IAChB;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,mBAAmB;;IAEnB;QACI,kBAAkB;IACtB;;IAEA;QACI,aAAa;QACb,uBAAuB;QACvB,mBAAmB;QACnB,SAAS;QACT,UAAU;QACV,YAAY;;QAEZ;YACI,UAAU;QACd;IACJ;AACJ;;AAEA;IACI,yDAAqE;IACrE,2BAA2B;IAC3B,sBAAsB;IACtB,uCAAuC;IACvC,aAAa;IACb,WAAW;;IAEX;QACI,eAAe;QACf,SAAS;IACb;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,mBAAmB;;IAEnB;QACI,aAAa;QACb,uBAAuB;IAC3B;AACJ;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,yDAAuE;IACvE,2BAA2B;IAC3B,4BAA4B;IAC5B,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,UAAU;IACV,YAAY;IACZ,mBAAmB;;IAEnB;QACI,SAAS;IACb;;IAEA;QACI,oBAAoB;IACxB;AACJ;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,aAAa;IACb,8BAA8B;;IAE9B;QACI,UAAU;QACV,WAAW;QACX,yBAAyB;QACzB,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,kBAAkB;QAClB,mBAAmB;IACvB;AACJ;;AAEA;;IAEI,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;;IAEI,eAAe;IACf,iBAAiB;IACjB,SAAS;AACb;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,cAAc;;IAEd;QACI,SAAS;QACT,oBAAoB;IACxB;AACJ;;AAEA;IACI,aAAa;IACb,UAAU;IACV,YAAY;IACZ,SAAS;;IAET;QACI,eAAe;IACnB;AACJ;;AAEA;;IAEI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,qCAAqC;;IAErC;QACI,aAAa;IACjB;;IAEA;QACI,gCAAgC;QAChC,+BAA+B;QAC/B,mBAAmB;IACvB;;IAEA;QACI,gCAAgC;QAChC,8BAA8B;QAC9B,mBAAmB;IACvB;;IAEA;QACI,6BAA6B;QAC7B,+BAA+B;QAC/B,mBAAmB;IACvB;;IAEA;QACI,6BAA6B;QAC7B,8BAA8B;QAC9B,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;AACJ;;AAEA;IACI,yDAAqE;IACrE,sBAAsB;IACtB,2BAA2B;IAC3B,4BAA4B;IAC5B,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;;IAEnB;QACI,UAAU;QACV,mBAAmB;;QAEnB;YACI,SAAS;YACT,oBAAoB;QACxB;IACJ;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA,mBAAmB;AACnB;IACI;QACI,aAAa;QACb,WAAW;;;QAGX;YACI,eAAe;QACnB;;QAEA;YACI,eAAe;QACnB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,sBAAsB;QACtB,SAAS;IACb;;IAEA;;QAEI,WAAW;IACf;;IAEA;QACI,aAAa;IACjB;AACJ;;;AAGA,mBAAmB;AACnB;IACI;QACI,sBAAsB;QACtB,0CAA0C;QAC1C,UAAU;QACV,eAAe;IACnB;;IAEA;;QAEI,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;;IAEA;;QAEI,eAAe;IACnB;;IAEA;QACI,sBAAsB;QACtB,UAAU;QACV,0CAA0C;IAC9C;;IAEA;QACI,WAAW;;QAEX;;YAEI,eAAe;QACnB;;QAEA;YACI,mBAAmB;QACvB;;QAEA;;YAEI,eAAe;YACf,mBAAmB;QACvB;IACJ;;IAEA;QACI,WAAW;QACX,WAAW;QACX,WAAW;QACX,iCAAiC;;QAEjC;YACI,eAAe;QACnB;;QAEA;YACI,eAAe;QACnB;IACJ;;IAEA;;QAEI,UAAU;;QAEV;YACI,eAAe;QACnB;IACJ;;IAEA;QACI,WAAW;QACX,qBAAqB;IACzB;;IAEA;QACI,UAAU;QACV,SAAS;QACT,YAAY;QACZ,sBAAsB;IAC1B;;IAEA;;QAEI,sBAAsB;IAC1B;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,UAAU;QACV,mBAAmB;QACnB,yBAAyB;IAC7B;;IAEA;QACI,UAAU;QACV,yBAAyB;IAC7B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,sBAAsB;QACtB,WAAW;QACX,qBAAqB;;QAErB;YACI,UAAU;QACd;IACJ;;IAEA;QACI,aAAa;QACb,WAAW;QACX,0CAA0C;;QAE1C;YACI,eAAe;QACnB;;QAEA;YACI,eAAe;QACnB;IACJ;;IAEA;QACI,SAAS;QACT;IACJ;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;QACtB,SAAS;QACT,UAAU;;QAEV;YACI,UAAU;YACV,WAAW;YACX,YAAY;QAChB;IACJ;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;QAChB,0CAA0C;IAC9C;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;QACX,qCAAqC;;;QAGrC;YACI,WAAW;YACX,YAAY;QAChB;IACJ;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,eAAe;QACf,aAAa;IACjB;AACJ;;;AAGA,mBAAmB;AACnB;IACI;QACI,eAAe;QACf,0CAA0C;IAC9C;;IAEA;;QAEI,eAAe;IACnB;;IAEA;QACI,UAAU;;QAEV;YACI,WAAW;QACf;IACJ;;IAEA;QACI,sBAAsB;QACtB,UAAU;QACV,0CAA0C;IAC9C;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;QACX,WAAW;QACX,WAAW;QACX,gCAAgC;IACpC;;IAEA;;QAEI,UAAU;;QAEV;YACI,eAAe;QACnB;IACJ;;IAEA;QACI,WAAW;QACX,mBAAmB;IACvB;;IAEA;QACI,UAAU;QACV,mBAAmB;QACnB,YAAY;QACZ,sBAAsB;IAC1B;;IAEA;;QAEI,sBAAsB;IAC1B;;IAEA;QACI,SAAS;IACb;;IAEA;;QAEI,UAAU;QACV,YAAY;QACZ,yBAAyB;IAC7B;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,0CAA0C;IAC9C;;IAEA;QACI,aAAa;QACb,WAAW;;QAEX;YACI,eAAe;QACnB;;QAEA;YACI,eAAe;QACnB;IACJ;;IAEA;QACI,SAAS;QACT;IACJ;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,mBAAmB;IACvB;;IAEA;;QAEI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,UAAU;QACV,YAAY;IAChB;;IAEA;QACI,iBAAiB;QACjB,0CAA0C;IAC9C;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;QACX,qCAAqC;;QAErC;YACI,WAAW;YACX,YAAY;QAChB;IACJ;;IAEA;QACI,WAAW;QACX,eAAe;QACf,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,iCAAiC;IACrC;AACJ","sourcesContent":[".data-engg-section-1 {\r\n    display: flex;\r\n    color: #20303F;\r\n    width: 80%;\r\n    margin: auto;\r\n    margin-bottom: 6rem;\r\n    margin-top: 250px;\r\n}\r\n\r\n.data-engg-section-1-left {\r\n    width: 75%;\r\n}\r\n\r\n.data-engg-section-1-left p:nth-child(1) {\r\n    margin: 0;\r\n    font-size: var(--font-size1);\r\n    font-weight: bold;\r\n}\r\n\r\n.data-engg-section-1-left p:nth-child(2) {\r\n    font-size: var(--font-size2);\r\n    font-weight: lighter;\r\n    margin: 0;\r\n}\r\n\r\n.data-engg-section-1-left span {\r\n    margin: 0;\r\n    font-size: var(--font-size2);\r\n    font-weight: 900;\r\n    margin: 0;\r\n}\r\n\r\n.data-engg-section-1-right {\r\n    width: 60%;\r\n\r\n    & img {\r\n        width: 100%;\r\n    }\r\n}\r\n\r\n.data-engg-section-3 {\r\n    display: flex;\r\n    width: 70%;\r\n    justify-content: center;\r\n    margin: auto;\r\n    margin-bottom: 9rem;\r\n}\r\n\r\n.data-engg-section-3-left {\r\n    width: 35%;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n\r\n    & p:nth-child(1) {\r\n        font-size: var(--font-size3);\r\n        margin: 0;\r\n    }\r\n\r\n    & p:nth-child(2) {\r\n        font-size: var(--font-size3);\r\n        font-weight: bold;\r\n        margin: 0;\r\n        margin-bottom: 2rem;\r\n    }\r\n\r\n    & p:nth-child(3),\r\n    & p:nth-child(4) {\r\n        font-size: var(--font-size4);\r\n        margin-bottom: 2rem;\r\n    }\r\n}\r\n\r\n.data-engg-section-3-right {\r\n    display: flex;\r\n    justify-content: space-around;\r\n    width: 50%;\r\n    background-image: url('../../assets/Services/DataEngg/section-3.png');\r\n    background-size: contain;\r\n    background-repeat: no-repeat;\r\n    background-position: center 190px;\r\n    border-radius: 1rem;\r\n    margin: auto;\r\n    padding: 2%;\r\n\r\n    & p:nth-child(1) {\r\n        font-size: var(--font-size6);\r\n        font-weight: bold;\r\n    }\r\n\r\n    & p:nth-child(2) {\r\n        font-size: 1.2rem\r\n    }\r\n}\r\n\r\n.data-engg-section-3-right-1,\r\n.data-engg-section-3-right-2 {\r\n    width: 50%;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    gap: 1rem;\r\n    padding: 0.5rem;\r\n\r\n\r\n    & div {\r\n        padding: 1rem;\r\n        background: rgba(255, 255, 255, 0.7);\r\n        backdrop-filter: blur(5px);\r\n        border-radius: 1rem;\r\n        border: 5px solid white;\r\n        box-shadow: rgba(17, 17, 26, 0.1) 0px 0px 16px;\r\n    }\r\n}\r\n\r\n.data-engg-section-4 {\r\n    width: 70%;\r\n    margin: auto;\r\n    margin-bottom: 5rem;\r\n}\r\n\r\n.data-engg-section-4-container {\r\n    padding: 5rem 0;\r\n    background-image: url('../../assets/Services/DataEngg/ellipse.png');\r\n    background-repeat: no-repeat;\r\n    background-position: center;\r\n}\r\n\r\n.data-engg-section-4-top {\r\n    font-size: 36px;\r\n    margin-bottom: 2rem;\r\n\r\n    p {\r\n        margin: 0;\r\n    }\r\n\r\n    & p:nth-child(1) {\r\n        font-weight: lighter;\r\n    }\r\n\r\n    & p:nth-child(2) {\r\n        font-weight: bold;\r\n    }\r\n}\r\n\r\n.data-engg-section-4-bottom-1,\r\n.data-engg-section-4-bottom-2 {\r\n    display: flex;\r\n    justify-content: space-between;\r\n\r\n    & div {\r\n        padding: 1rem;\r\n        border-radius: 1rem;\r\n        background: white;\r\n    }\r\n}\r\n\r\n.data-engg-section-4-bottom-1 div {\r\n    width: 30%;\r\n    margin-bottom: 2rem;\r\n}\r\n\r\n.data-engg-section-4-bottom-2 div {\r\n    width: 45%;\r\n}\r\n\r\n.data-engg-section-4-bottom-1,\r\n.data-engg-section-4-bottom-2 {\r\n    & img {\r\n        width: 70px;\r\n        height: 70px;\r\n    }\r\n}\r\n\r\n.section-4-bold-head {\r\n    font-size: 32px;\r\n    font-weight: bold;\r\n}\r\n\r\n.section-4-desc {\r\n    font-size: 18px;\r\n}\r\n\r\n.data-engg-section-5 {\r\n    padding: 1%;\r\n    display: flex;\r\n    font-size: 24px;\r\n    font-weight: 400;\r\n    justify-content: center;\r\n    align-items: center;\r\n    gap: 3rem;\r\n    margin-bottom: 5rem;\r\n\r\n    & div:nth-child(1) {\r\n        width: max-content;\r\n    }\r\n\r\n    & div:nth-child(2) {\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;\r\n        gap: 2rem;\r\n        width: 20%;\r\n        height: 50px;\r\n\r\n        & img {\r\n            width: 50%;\r\n        }\r\n    }\r\n}\r\n\r\n.data-engg-section-6 {\r\n    background-image: url('../../assets/Services/DataEngg/section-6.png');\r\n    background-position: center;\r\n    background-size: cover;\r\n    margin-bottom: var(--margin-bottom-web);\r\n    height: 600px;\r\n    padding: 1%;\r\n\r\n    & p:nth-child(1) {\r\n        font-size: 72px;\r\n        margin: 0;\r\n    }\r\n\r\n    & p:nth-child(2) {\r\n        font-size: 24px;\r\n    }\r\n}\r\n\r\n.section-6-content {\r\n    display: flex;\r\n    flex-direction: column;\r\n    width: 45%;\r\n    margin: auto;\r\n    text-align: center;\r\n    gap: 10rem;\r\n    height: max-content;\r\n\r\n    & div:nth-child(2) {\r\n        display: flex;\r\n        justify-content: center;\r\n    }\r\n}\r\n\r\n.data-engg-section-7 {\r\n    margin-bottom: 10rem;\r\n}\r\n\r\n.section-7-bg {\r\n    background-image: url('../../assets/Services//DataEngg/wavelength.png');\r\n    background-position: center;\r\n    background-repeat: no-repeat;\r\n    background-size: cover;\r\n}\r\n\r\n.section-7-top {\r\n    font-size: 28px;\r\n    width: 70%;\r\n    margin: auto;\r\n    margin-bottom: 2rem;\r\n\r\n    & p {\r\n        margin: 0;\r\n    }\r\n\r\n    & p:nth-child(1) {\r\n        font-weight: lighter;\r\n    }\r\n}\r\n\r\n.section-7-bottom {\r\n    width: 70%;\r\n    margin: auto;\r\n    display: flex;\r\n    justify-content: space-between;\r\n\r\n    & div {\r\n        width: 30%;\r\n        padding: 1%;\r\n        border: 1px solid #90C8E5;\r\n        background: white;\r\n        border-radius: 1em;\r\n    }\r\n\r\n    & img {\r\n        width: 100%;\r\n        aspect-ratio: 16/9;\r\n        border-radius: 1rem;\r\n    }\r\n}\r\n\r\n.section-7-title,\r\n.section-7-desc {\r\n    font-size: 16px;\r\n}\r\n\r\n.section-7-title {\r\n    font-weight: bold;\r\n}\r\n\r\n.section-7-head {\r\n    font-size: 21px;\r\n}\r\n\r\n.data-engg-section-8 {\r\n    margin-top: 0px;\r\n    margin-bottom: -25%;\r\n}\r\n\r\n.data-engg-section-8-top {\r\n    text-align: center;\r\n    color: #20303F;\r\n}\r\n\r\n.data-engg-section-8-top>:nth-child(3) {\r\n    margin-top: 12px;\r\n    font-size: 20px;\r\n    font-weight: 400;\r\n    line-height: 30.66px;\r\n}\r\n\r\n.data-engg-section-8-top>:nth-child(1),\r\n.data-engg-section-8-top>:nth-child(2) {\r\n    font-size: 36px;\r\n    line-height: 48px;\r\n    margin: 0;\r\n}\r\n\r\n.data-engg-section-9 {\r\n    margin-bottom: 10rem;\r\n}\r\n\r\n.section-9-top {\r\n    width: 80%;\r\n    margin: auto;\r\n    margin-bottom: 2rem;\r\n    font-size: 28px;\r\n    color: #20303F;\r\n\r\n    & p {\r\n        margin: 0;\r\n        font-weight: lighter;\r\n    }\r\n}\r\n\r\n.section-9-bottom {\r\n    display: flex;\r\n    width: 80%;\r\n    margin: auto;\r\n    gap: 1rem;\r\n\r\n    & ul {\r\n        font-size: 14px;\r\n    }\r\n}\r\n\r\n.data-engg-section-9-bottom-left,\r\n.data-engg-section-9-bottom-right {\r\n    width: 50%;\r\n}\r\n\r\n.data-engg-section-9-bottom-left {\r\n    display: grid;\r\n    grid-template-columns: repeat(2, 1fr);\r\n\r\n    & div {\r\n        padding: 1rem;\r\n    }\r\n\r\n    & div:nth-child(1) {\r\n        border-bottom: 1px solid #4FC1AD;\r\n        border-right: 1px solid #4FC1AD;\r\n        border-radius: 40px;\r\n    }\r\n\r\n    & div:nth-child(2) {\r\n        border-bottom: 1px solid #4FC1AD;\r\n        border-left: 1px solid #4FC1AD;\r\n        border-radius: 40px;\r\n    }\r\n\r\n    & div:nth-child(3) {\r\n        border-top: 1px solid #4FC1AD;\r\n        border-right: 1px solid #4FC1AD;\r\n        border-radius: 40px;\r\n    }\r\n\r\n    & div:nth-child(4) {\r\n        border-top: 1px solid #4FC1AD;\r\n        border-left: 1px solid #4FC1AD;\r\n        border-radius: 40px;\r\n    }\r\n\r\n    & img {\r\n        width: 60px;\r\n        height: 60px;\r\n    }\r\n}\r\n\r\n.data-engg-section-9-bottom-right {\r\n    background-image: url('../../assets/Services/DataEngg/section-9.png');\r\n    background-size: cover;\r\n    background-position: center;\r\n    background-repeat: no-repeat;\r\n    font-size: 36px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: end;\r\n    align-items: center;\r\n    color: white;\r\n    border-radius: 1rem;\r\n\r\n    & div {\r\n        width: 90%;\r\n        margin-bottom: 2rem;\r\n\r\n        & p {\r\n            margin: 0;\r\n            font-weight: lighter;\r\n        }\r\n    }\r\n}\r\n\r\n.section-9-bottom-head {\r\n    font-size: 20px;\r\n    font-weight: bold;\r\n}\r\n\r\n/* Tablet Version */\r\n@media screen and (min-width:960px) and (max-width: 1360px) {\r\n    .data-engg-section-6 {\r\n        height: 400px;\r\n        padding: 1%;\r\n\r\n\r\n        & p:nth-child(1) {\r\n            font-size: 48px;\r\n        }\r\n\r\n        & p:nth-child(2) {\r\n            font-size: 20px;\r\n        }\r\n    }\r\n\r\n    .section-6-content {\r\n        gap: 5rem\r\n    }\r\n\r\n    .data-engg-section-9 {\r\n        margin-top: 25rem;\r\n    }\r\n\r\n    .section-9-bottom {\r\n        flex-direction: column;\r\n        gap: 2rem;\r\n    }\r\n\r\n    .data-engg-section-9-bottom-left,\r\n    .data-engg-section-9-bottom-right {\r\n        width: 100%;\r\n    }\r\n\r\n    .data-engg-section-9-bottom-right {\r\n        height: 800px;\r\n    }\r\n}\r\n\r\n\r\n/* Mobile Version */\r\n@media screen and (min-width:300px) and (max-width: 500px) {\r\n    .data-engg-section-1 {\r\n        flex-direction: column;\r\n        margin-bottom: var(--margin-bottom-mobile);\r\n        width: 80%;\r\n        margin-top: 0px;\r\n    }\r\n\r\n    .data-engg-section-1-left,\r\n    .data-engg-section-1-right {\r\n        width: 100%;\r\n    }\r\n\r\n    .data-engg-section-1-left p:nth-child(1) {\r\n        font-size: 21px;\r\n    }\r\n\r\n    .data-engg-section-1-left p:nth-child(2),\r\n    .data-engg-section-1-left span {\r\n        font-size: 41px;\r\n    }\r\n\r\n    .data-engg-section-3 {\r\n        flex-direction: column;\r\n        width: 90%;\r\n        margin-bottom: var(--margin-bottom-mobile);\r\n    }\r\n\r\n    .data-engg-section-3-left {\r\n        width: 100%;\r\n\r\n        & p:nth-child(1),\r\n        & p:nth-child(2) {\r\n            font-size: 28px;\r\n        }\r\n\r\n        & p:nth-child(2) {\r\n            margin-bottom: 1rem;\r\n        }\r\n\r\n        & p:nth-child(3),\r\n        & p:nth-child(4) {\r\n            font-size: 14px;\r\n            margin-bottom: 1rem;\r\n        }\r\n    }\r\n\r\n    .data-engg-section-3-right {\r\n        width: 100%;\r\n        padding: 1%;\r\n        gap: 0.5rem;\r\n        background-position: center 140px;\r\n\r\n        & p:nth-child(1) {\r\n            font-size: 20px;\r\n        }\r\n\r\n        & p:nth-child(2) {\r\n            font-size: 15px;\r\n        }\r\n    }\r\n\r\n    .data-engg-section-3-right-1,\r\n    .data-engg-section-3-right-2 {\r\n        padding: 0;\r\n\r\n        & div {\r\n            padding: 0.5rem;\r\n        }\r\n    }\r\n\r\n    .data-engg-section-4 {\r\n        width: 100%;\r\n        margin-bottom: 2.5rem;\r\n    }\r\n\r\n    .data-engg-section-4-container {\r\n        width: 80%;\r\n        padding:0;\r\n        margin: auto;\r\n        background-image: none;\r\n    }\r\n\r\n    .data-engg-section-4-bottom-1,\r\n    .data-engg-section-4-bottom-2 {\r\n        flex-direction: column;\r\n    }\r\n\r\n    .data-engg-section-4-bottom-2 {\r\n        gap: 2rem;\r\n    }\r\n\r\n    .data-engg-section-4-bottom-1 div {\r\n        width: 90%;\r\n        margin-bottom: 2rem;\r\n        border: 1px solid #4fc2ac;\r\n    }\r\n\r\n    .data-engg-section-4-bottom-2 div {\r\n        width: 90%;\r\n        border: 1px solid #4fc2ac;\r\n    }\r\n\r\n    .section-4-bold-head {\r\n        font-size: 24px;\r\n    }\r\n\r\n    .section-4-desc {\r\n        font-size: 14px;\r\n    }\r\n\r\n    .data-engg-section-5 {\r\n        flex-direction: column;\r\n        gap: 0.5rem;\r\n        margin-bottom: 2.5rem;\r\n\r\n        & div:nth-child(2) {\r\n            width: 50%;\r\n        }\r\n    }\r\n\r\n    .data-engg-section-6 {\r\n        height: 400px;\r\n        padding: 1%;\r\n        margin-bottom: var(--margin-bottom-mobile);\r\n\r\n        & p:nth-child(1) {\r\n            font-size: 36px;\r\n        }\r\n\r\n        & p:nth-child(2) {\r\n            font-size: 16px;\r\n        }\r\n    }\r\n\r\n    .section-6-content {\r\n        gap: 5rem;\r\n        width: 85%\r\n    }\r\n\r\n    .data-engg-section-7 {\r\n        margin-bottom: 5rem;\r\n    }\r\n\r\n    .section-7-bg {\r\n        background-image: none;\r\n    }\r\n\r\n    .section-7-bottom {\r\n        flex-direction: column;\r\n        gap: 1rem;\r\n        width: 90%;\r\n\r\n        & div {\r\n            width: 90%;\r\n            padding: 2%;\r\n            margin: auto;\r\n        }\r\n    }\r\n\r\n    .data-engg-section-8 {\r\n        margin-bottom: -10%;\r\n    }\r\n\r\n    .data-engg-section-9 {\r\n        margin-top: 8rem;\r\n        margin-bottom: var(--margin-bottom-mobile);\r\n    }\r\n\r\n    .section-9-bottom {\r\n        flex-direction: column;\r\n    }\r\n\r\n    .data-engg-section-9-bottom-left {\r\n        width: 100%;\r\n        grid-template-columns: repeat(1, 1fr);\r\n\r\n\r\n        & img {\r\n            width: 40px;\r\n            height: 40px;\r\n        }\r\n    }\r\n\r\n    .section-9-bottom-head {\r\n        font-size: 24px;\r\n    }\r\n\r\n    .data-engg-section-9-bottom-right {\r\n        width: 100%;\r\n        font-size: 30px;\r\n        height: 400px;\r\n    }\r\n}\r\n\r\n\r\n/* Tablet Version */\r\n@media screen and (min-width:600px) and (max-width: 1024px) {\r\n    .data-engg-section-1 {\r\n        margin-top: 0px;\r\n        margin-bottom: var(--margin-bottom-mobile);\r\n    }\r\n\r\n    .data-engg-section-1-left p:nth-child(2),\r\n    .data-engg-section-1-left span {\r\n        font-size: 45px;\r\n    }\r\n\r\n    .data-engg-section-1-right {\r\n        width: 70%;\r\n\r\n        & img {\r\n            width: 100%;\r\n        }\r\n    }\r\n\r\n    .data-engg-section-3 {\r\n        flex-direction: column;\r\n        width: 90%;\r\n        margin-bottom: var(--margin-bottom-mobile);\r\n    }\r\n\r\n    .data-engg-section-3-left {\r\n        width: 100%;\r\n    }\r\n\r\n    .data-engg-section-3-right {\r\n        width: 100%;\r\n        padding: 1%;\r\n        gap: 0.5rem;\r\n        background-position: center 60px;\r\n    }\r\n\r\n    .data-engg-section-3-right-1,\r\n    .data-engg-section-3-right-2 {\r\n        padding: 0;\r\n\r\n        & div {\r\n            padding: 0.5rem;\r\n        }\r\n    }\r\n\r\n    .data-engg-section-4 {\r\n        width: 100%;\r\n        margin-bottom: 5rem;\r\n    }\r\n\r\n    .data-engg-section-4-container {\r\n        width: 80%;\r\n        padding: 3rem 0 0 0;\r\n        margin: auto;\r\n        background-image: none;\r\n    }\r\n\r\n    .data-engg-section-4-bottom-1,\r\n    .data-engg-section-4-bottom-2 {\r\n        flex-direction: column;\r\n    }\r\n\r\n    .data-engg-section-4-bottom-2 {\r\n        gap: 2rem;\r\n    }\r\n\r\n    .data-engg-section-4-bottom-1 div,\r\n    .data-engg-section-4-bottom-2 div {\r\n        width: 90%;\r\n        margin: auto;\r\n        border: 1px solid #4fc2ac;\r\n    }\r\n\r\n    .data-engg-section-4-bottom-1 div {\r\n        margin-bottom: 2rem;\r\n    }\r\n\r\n    .data-engg-section-5 {\r\n        margin-bottom: var(--margin-bottom-mobile);\r\n    }\r\n\r\n    .data-engg-section-6 {\r\n        height: 400px;\r\n        padding: 1%;\r\n\r\n        & p:nth-child(1) {\r\n            font-size: 36px;\r\n        }\r\n\r\n        & p:nth-child(2) {\r\n            font-size: 16px;\r\n        }\r\n    }\r\n\r\n    .section-6-content {\r\n        gap: 6rem;\r\n        width: 60%\r\n    }\r\n\r\n    .data-engg-section-7 {\r\n        width: 100%;\r\n        margin: auto;\r\n        margin-bottom: 5rem;\r\n    }\r\n\r\n    .section-7-title,\r\n    .section-7-desc {\r\n        font-size: 14px;\r\n    }\r\n\r\n    .section-7-head {\r\n        font-size: 18px;\r\n    }\r\n\r\n    .section-7-top {\r\n        width: 90%;\r\n    }\r\n\r\n    .section-7-bottom {\r\n        width: 90%;\r\n        margin: auto;\r\n    }\r\n\r\n    .data-engg-section-9 {\r\n        margin-top: 20rem;\r\n        margin-bottom: var(--margin-bottom-mobile);\r\n    }\r\n\r\n    .section-9-bottom {\r\n        flex-direction: column;\r\n    }\r\n\r\n    .data-engg-section-9-bottom-left {\r\n        width: 100%;\r\n        grid-template-columns: repeat(2, 1fr);\r\n\r\n        & img {\r\n            width: 40px;\r\n            height: 40px;\r\n        }\r\n    }\r\n\r\n    .data-engg-section-9-bottom-right {\r\n        width: 100%;\r\n        font-size: 30px;\r\n        height: 800px;\r\n    }\r\n}\r\n\r\n@media screen and (min-width:600px) and (max-width:700px) {\r\n    .data-engg-section-3-right {\r\n        background-position: center 150px;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
